import { render } from "./Modal.vue?vue&type=template&id=6f7ceb67"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=6f7ceb67&lang=css"
script.render = render

export default script